import axios from 'axios';
import { adminMainUrl } from '../../../Config';

// port list
export const fetchCCPortListRequest = () => ({
    type: "FIND_CC_PORT_LIST_REQUEST",
});

export const fetchCCPortListSuccess = (data) => ({
    type: "FIND_CC_PORT_LIST_SUCCESS",
    payload: data,
});

export const fetchCCPortListFailure = (error) => ({
    type: "FIND_CC_PORT_LIST_FAILURE",
    payload: error,
});

export const getCCPortList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchCCPortListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/port/list`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchCCPortListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getCCPortList function (redux):", err);
                dispatch(fetchCCPortListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getCCPortList function:", error);
            dispatch(fetchCCPortListFailure(error));
        }
    };
};

// port list

// custom house list
export const fetchCCCustomHouseListRequest = () => ({
    type: "FIND_CC_CUSTOM_HOUSE_LIST_REQUEST",
});

export const fetchCCCustomHouseListSuccess = (data) => ({
    type: "FIND_CC_CUSTOM_HOUSE_LIST_SUCCESS",
    payload: data,
});

export const fetchCCCustomHouseListFailure = (error) => ({
    type: "FIND_CC_CUSTOM_HOUSE_LIST_FAILURE",
    payload: error,
});

export const getCCCustomHouseList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchCCCustomHouseListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/custom-house/get`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchCCCustomHouseListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getCCCustomHouseList function (redux):", err);
                dispatch(fetchCCCustomHouseListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getCCCustomHouseList function:", error);
            dispatch(fetchCCCustomHouseListFailure(error));
        }
    };
};

// custom house list

// employee list
export const fetchCCEmployeeListRequest = () => ({
    type: "FIND_CC_EMPLOYEE_LIST_REQUEST",
});

export const fetchCCEmployeeListSuccess = (data) => ({
    type: "FIND_CC_EMPLOYEE_LIST_SUCCESS",
    payload: data,
});

export const fetchCCEmployeeListFailure = (error) => ({
    type: "FIND_CC_EMPLOYEE_LIST_FAILURE",
    payload: error,
});

export const getCCEmployeeList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchCCEmployeeListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/employee-list`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchCCEmployeeListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getCCEmployeeList function (redux):", err);
                dispatch(fetchCCEmployeeListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getCCEmployeeList function:", error);
            dispatch(fetchCCEmployeeListFailure(error));
        }
    };
};

// employee list

// unused job order list
export const fetchCCUnusedJobOrderListRequest = () => ({
    type: "FIND_CC_UNUSED_JOBORDER_LIST_REQUEST",
});

export const fetchCCUnusedJobOrderListSuccess = (data) => ({
    type: "FIND_CC_UNUSED_JOBORDER_LIST_SUCCESS",
    payload: data,
});

export const fetchCCUnusedJobOrderListFailure = (error) => ({
    type: "FIND_CC_UNUSED_JOBORDER_LIST_FAILURE",
    payload: error,
});

export const getCCUnusedJobOrderList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchCCUnusedJobOrderListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/customClearance/unused-job-order`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchCCUnusedJobOrderListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getCCUnusedJobOrderList function (redux):", err);
                dispatch(fetchCCUnusedJobOrderListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getCCUnusedJobOrderList function:", error);
            dispatch(fetchCCUnusedJobOrderListFailure(error));
        }
    };
};

// unused job order list

// employee list
export const fetchCCCountryListRequest = () => ({
    type: "FIND_CC_COUNTRY_LIST_REQUEST",
});

export const fetchCCCountryListSuccess = (data) => ({
    type: "FIND_CC_COUNTRY_LIST_SUCCESS",
    payload: data,
});

export const fetchCCCountryListFailure = (error) => ({
    type: "FIND_CC_COUNTRY_LIST_FAILURE",
    payload: error,
});

export const getCCCountryList = (token, user_id) => {
    return async function (dispatch) {
        dispatch(fetchCCCountryListRequest());
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/country/list`;

        try {
            axios(apiUrl, config).then((res) => {
                dispatch(fetchCCCountryListSuccess(res.data?.data));
            }).catch((err) => {
                console.log("ERROR in getCCCountryList function (redux):", err);
                dispatch(fetchCCCountryListFailure(err));
            });
        } catch (error) {
            console.log("Unexpected error in getCCCountryList function:", error);
            dispatch(fetchCCCountryListFailure(error));
        }
    };
};

// employee list


//airline list
export const getCCAirlineList = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_AIRLINE_LIST_REQUEST",
        });
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/airline/get`;
        // const body = { id: id }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_CC_AIRLINE_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCCAirlineList function (redux):", err);
                dispatch({
                    type: "FIND_CC_AIRLINE_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCCAirlineList function:", error);
            dispatch({
                type: "FIND_CC_AIRLINE_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
//airline list

//shipline list
export const getCCShiplineList = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_SHIPLINE_LIST_REQUEST",
        });
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/shipline/get`;
        // const body = { id: id }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_CC_SHIPLINE_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCCShiplineList function (redux):", err);
                dispatch({
                    type: "FIND_CC_SHIPLINE_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCCShiplineList function:", error);
            dispatch({
                type: "FIND_CC_SHIPLINE_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
//shipline list



// custom clearance -> export job

export const getCCExpJobDetail = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_EXP_JOB_DETAIL_REQUEST",
        });
        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/customClearance/view`;
        const body = { id: id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_CC_EXP_JOB_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCCExpJobDetail function (redux):", err);
                dispatch({
                    type: "FIND_CC_EXP_JOB_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCCExpJobDetail function:", error);
            dispatch({
                type: "FIND_CC_EXP_JOB_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};

// custom clearance -> export job detail 

//cc -> export job -> organisation List
export const getCCExportOrganisationList = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_EXP_JOB_ORGANISATION_LIST_REQUEST",
        });
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/all-list`;
        // const body = { id: id }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_CC_EXP_JOB_ORGANISATION_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCCExpJob function (redux):", err);
                dispatch({
                    type: "FIND_CC_EXP_JOB_ORGANISATION_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCCExpJob function:", error);
            dispatch({
                type: "FIND_CC_EXP_JOB_ORGANISATION_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
//cc -> export job -> organisation List

//cc -> export job -> organisation branch List
export const getCCExportShipperOrganisationBranchList = (token, user_id, org_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_BRANCH_LIST_REQUEST",
        });
        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/general/branch/list`;
        const body = { customer_id: org_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_BRANCH_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCCExpJob function (redux):", err);
                dispatch({
                    type: "FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_BRANCH_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCCExpJob function:", error);
            dispatch({
                type: "FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_BRANCH_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
//cc -> export job -> organisation branch List

//cc -> export job -> organisation reg List
export const getCCExportShipperOrganisationRegList = (token, user_id, org_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_REG_LIST_REQUEST",
        });
        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/reg/list`;
        const body = { customer_id: org_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                // console.log(res.data.data);
                dispatch({
                    type: "FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_REG_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCCExportShipperOrganisationRegList function (redux):", err);
                dispatch({
                    type: "FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_REG_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCCExportShipperOrganisationRegList function:", error);
            dispatch({
                type: "FIND_CC_EXP_JOB_SHIPPER_ORGANISATION_REG_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
//cc -> export job -> organisation reg List

//cc -> export job -> organisation branch List consignee
export const getCCExportConsigneeOrganisationBranchList = (token, user_id, org_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_EXP_JOB_CONSIGNEE_ORGANISATION_BRANCH_LIST_REQUEST",
        });
        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/organization/general/branch/list`;
        const body = { customer_id: org_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_CC_EXP_JOB_CONSIGNEE_ORGANISATION_BRANCH_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCCExpJob function (redux):", err);
                dispatch({
                    type: "FIND_CC_EXP_JOB_CONSIGNEE_ORGANISATION_BRANCH_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCCExpJob function:", error);
            dispatch({
                type: "FIND_CC_EXP_JOB_CONSIGNEE_ORGANISATION_BRANCH_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
//cc -> export job -> organisation branch List consignee





// Job Order List

export const fetchJobOrderListCCRequest = () => ({
    type: "FIND_JOB_ORDER_LIST_CC_REQUEST",
});

export const fetchJobOrderListCCSuccess = (data) => ({
    type: "FIND_JOB_ORDER_LIST_CC_SUCCESS",
    payload: data,
});

export const fetchJobOrderListCCFailure = (error) => ({
    type: "FIND_JOB_ORDER_LIST_CC_FAILURE",
    payload: error,
});



export const getJobOrderListCC = (token, user_id, current_page = 1, queryParams = {}) => {
    return async function (dispatch) {
        // Dispatch the request action
        dispatch(fetchJobOrderListCCRequest());

        // Construct query parameters for the URL
        const params = new URLSearchParams(queryParams);
        params.delete('page'); // Ensure 'page' isn't duplicated in the query string

        // Build the API URL with the current page and additional query parameters
        const apiUrl = `${adminMainUrl}/api/customClearance/list?page=${current_page}&${params.toString()}`;

        // Configuration for the fetch request
        const config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            },
        };

        try {
            // Make the API call
            const response = await fetch(apiUrl, config);

            // Check for HTTP errors
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // Parse the JSON response
            const data = await response.json();

            // Log the response data for debugging
            // console.log("Response Data:", data);

            // Dispatch the success action with response data
            dispatch(fetchJobOrderListCCSuccess(data));
        } catch (error) {
            // Log and dispatch the failure action
            console.error("ERROR in getJobOrderListCC function (redux):", error);
            dispatch(fetchJobOrderListCCFailure(error.message));
        }
    };
};

// Job Order List
// custom clearance -> export job Order List


//cc -> export job -> hsn ritc codes list
export const getCCJobOrderExportHSNRITCCodesList = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_EXP_JOB_HSN_RITC_CODE_LIST_REQUEST",
        });
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/ritc-hsn/get`;
        // const body = { customer_id: org_id }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_CC_EXP_JOB_HSN_RITC_CODE_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCCExpJob function (redux):", err);
                dispatch({
                    type: "FIND_CC_EXP_JOB_HSN_RITC_CODE_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCCExpJob function:", error);
            dispatch({
                type: "FIND_CC_EXP_JOB_HSN_RITC_CODE_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
//cc -> export job -> hsn ritc codes list

//cc -> export job -> currency codes list
export const getCCJobOrderExporCurrencyList = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_EXP_JOB_HSN_CURRENCY_LIST_REQUEST",
        });
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/currency/list`;
        // const body = { customer_id: org_id }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_CC_EXP_JOB_HSN_CURRENCY_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCCExpJob function (redux):", err);
                dispatch({
                    type: "FIND_CC_EXP_JOB_HSN_CURRENCY_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCCExpJob function:", error);
            dispatch({
                type: "FIND_CC_EXP_JOB_HSN_CURRENCY_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
//cc -> export job -> currency codes list


//cc -> export job -> product list
export const getCCJobOrderExportProductList = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_EXP_JOB_PRODUCT_LIST_REQUEST",
        });
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/currency/list`;
        // const body = { customer_id: org_id }
        try {
            axios(apiUrl, config).then((res) => {
                console.log(res.data);
                dispatch({
                    type: "FIND_CC_EXP_JOB_PRODUCT_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCCExpJob function (redux):", err);
                dispatch({
                    type: "FIND_CC_EXP_JOB_PRODUCT_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCCExpJob function:", error);
            dispatch({
                type: "FIND_CC_EXP_JOB_PRODUCT_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
//cc -> export job -> product list



// Invoice Tab 

//cc -> export job -> invoice list
export const getCCJobOrderExportInvoiceList = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_EXP_JOB_INVOICE_LIST_REQUEST",
        });
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/customClearance/invoice/list`;
        const body = { custom_clearance_export_job_id: id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_CC_EXP_JOB_INVOICE_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCCExpJob function (redux):", err);
                dispatch({
                    type: "FIND_CC_EXP_JOB_INVOICE_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCCExpJob function:", error);
            dispatch({
                type: "FIND_CC_EXP_JOB_INVOICE_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
//cc -> export job -> invoice list

//cc -> export job -> invoice detail
export const getCCJobOrderExportInvoiceDetail = (token, user_id, export_job_id, invoice_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_EXP_JOB_INVOICE_DETAIL_REQUEST",
        });
        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/customClearance/invoice/view`;
        const body = { id: invoice_id, custom_clearance_export_job_id: export_job_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_CC_EXP_JOB_INVOICE_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCCExpJob function (redux):", err);
                dispatch({
                    type: "FIND_CC_EXP_JOB_INVOICE_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCCExpJob function:", error);
            dispatch({
                type: "FIND_CC_EXP_JOB_INVOICE_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};
//cc -> export job -> invoice detail


export const getProductListAccordingToInvoiceList = (token, user_id, id, invoice_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_EXP_PRODUCT_LIST_REQUEST",
        });
        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/customClearance/product/list`;
        const body = {
            custom_clearance_export_job_id: id,
            custom_clearance_export_job_invoice_id: invoice_id
        }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_CC_EXP_PRODUCT_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getProductListAccordingToInvoiceList function (redux):", err);
                dispatch({
                    type: "FIND_CC_EXP_PRODUCT_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getProductListAccordingToInvoiceList function:", error);
            dispatch({
                type: "FIND_CC_EXP_PRODUCT_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
//cc -> export job -> product according to invoice list

//cc -> export job -> product according to invoice detail
export const getCCExpJobProductData = (token, user_id, id, invoice_id, product_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_EXP_PRODUCT_DETAIL_REQUEST",
        });
        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/customClearance/product/view`;
        const body = {
            id: product_id,
            custom_clearance_export_job_id: id,
            custom_clearance_export_job_invoice_id: invoice_id
        }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_CC_EXP_PRODUCT_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getProductListAccordingToInvoiceList function (redux):", err);
                dispatch({
                    type: "FIND_CC_EXP_PRODUCT_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getProductListAccordingToInvoiceList function:", error);
            dispatch({
                type: "FIND_CC_EXP_PRODUCT_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};
//cc -> export job -> product according to invoice detail


// Job Order List

export const fetchJobOrderListImportCCRequest = () => ({
    type: "FIND_JOB_ORDER_LIST_IMPORT_CC_REQUEST",
});

export const fetchJobOrderListImportCCSuccess = (data) => ({
    type: "FIND_JOB_ORDER_LIST_IMPORT_CC_SUCCESS",
    payload: data,
});

export const fetchJobOrderListImportCCFailure = (error) => ({
    type: "FIND_JOB_ORDER_LIST_IMPORT_CC_FAILURE",
    payload: error,
});




export const getJobOrderListImportCC = (token, user_id, current_page = 1, queryParams = {}) => {
    return async function (dispatch) {
        // Dispatch the request action
        dispatch(fetchJobOrderListImportCCRequest());

        // Construct query parameters for the URL
        const params = new URLSearchParams(queryParams);
        params.delete('page'); // Ensure 'page' isn't duplicated in the query string

        // Build the API URL with the current page and additional query parameters
        const apiUrl = `${adminMainUrl}/api/customClearance/import/list?page=${current_page}&${params.toString()}`;

        // Configuration for the fetch request
        const config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            },
        };

        try {
            // Make the API call
            const response = await fetch(apiUrl, config);

            // Check for HTTP errors
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // Parse the JSON response
            const data = await response.json();

            // Log the response data for debugging
            // console.log("Response Data:", data);

            // Dispatch the success action with response data
            dispatch(fetchJobOrderListImportCCSuccess(data));
        } catch (error) {
            // Log and dispatch the failure action
            console.error("ERROR in getJobOrderListImportCC function (redux):", error);
            dispatch(fetchJobOrderListImportCCFailure(error.message));
        }
    };
};

// Job Order List
// custom clearance -> export job Order List


//cc -> import job -> invoice list
export const getCCJobOrderImportInvoiceList = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_IMPORT_JOB_INVOICE_LIST_REQUEST",
        });
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/customClearance/import/invoice/list`;
        const body = { custom_clearance_import_job_id: id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_CC_IMPORT_JOB_INVOICE_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCCImportJob function (redux):", err);
                dispatch({
                    type: "FIND_CC_IMPORT_JOB_INVOICE_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCCImportJob function:", error);
            dispatch({
                type: "FIND_CC_IMPORT_JOB_INVOICE_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
//cc -> import job -> invoice list

//cc -> import job -> invoice detail
export const getCCJobOrderImportInvoiceDetail = (token, user_id, import_job_id, invoice_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_IMPORT_JOB_INVOICE_DETAIL_REQUEST",
        });
        let config = {
            // method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/customClearance/import/invoice/view`;
        const body = { id: invoice_id, custom_clearance_import_job_id: import_job_id }
        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_CC_IMPORT_JOB_INVOICE_DETAIL_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCCImportJob function (redux):", err);
                dispatch({
                    type: "FIND_CC_IMPORT_JOB_INVOICE_DETAIL_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCCImportJob function:", error);
            dispatch({
                type: "FIND_CC_IMPORT_JOB_INVOICE_DETAIL_FAILURE",
                payload: error,
            });
        }
    };
};
//cc -> Import job -> invoice detail

//cc -> export job -> currency codes list
export const getCCJobOrderImportCurrencyList = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_CC_IMPORT_JOB_HSN_CURRENCY_LIST_REQUEST",
        });
        let config = {
            method: "GET",
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };

        const apiUrl = `${adminMainUrl}/api/currency/list`;
        // const body = { customer_id: org_id }
        try {
            axios(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_CC_IMPORT_JOB_HSN_CURRENCY_LIST_SUCCESS",
                    payload: res?.data?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getCCImportJob function (redux):", err);
                dispatch({
                    type: "FIND_CC_IMPORT_JOB_HSN_CURRENCY_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getCCImportJob function:", error);
            dispatch({
                type: "FIND_CC_IMPORT_JOB_HSN_CURRENCY_LIST_FAILURE",
                payload: error,
            });
        }
    };
};
//cc -> export job -> currency codes list
